module.exports = __webpack_public_path__ + "static/media/wjc_logo.7a6c0960.svg";